export default import.meta.ROLLDOWN_FILE_URL_GDF_$j5oOz7nShNs2BN1nQ